/*!
 * Currently there are separate experiences and metrics for assign/unassign and hundreds of lines of
 * boilerplate code to handle that split. This is part of the same thing.
 *
 * We should remove this duplication.
 */

import { UNASSIGNED_EPIC_ID } from '../../../../../../common/constants.tsx';
import {
	useAssignEpicPanelExperienceTracker,
	useUnassignEpicPanelExperienceTracker,
} from '../../../../../../services/experience-tracker/index.tsx';
import { assignEpicUtils, unassignEpicUtils } from './constants.tsx';

/**
 * TODO: Deprecate all this duplication of assign/unassign
 * @deprecated Don't use
 */
export function useDropToAssignExperienceTracker({
	epicId,
	isCompanyManaged: isClassic,
}: {
	epicId: number;
	isCompanyManaged: boolean;
}) {
	const isAssign = epicId !== UNASSIGNED_EPIC_ID;
	const options = {
		isClassic,
	};
	const assignTracker = useAssignEpicPanelExperienceTracker(options);
	const unassignTracker = useUnassignEpicPanelExperienceTracker(options);
	return isAssign ? assignTracker : unassignTracker;
}

/**
 * TODO: Deprecate all this duplication of assign/unassign
 * @deprecated Don't use
 */
export function getDropToAssignMarks({ epicId }: { epicId: number }) {
	const isAssign = epicId !== UNASSIGNED_EPIC_ID;
	return isAssign ? assignEpicUtils : unassignEpicUtils;
}
